import type {
	CreateDiscountBody,
	UpdateDiscountBody,
} from "@/features/discounts/api/types";
import type { OfferFormValues } from "@/features/discounts/lib/offer-schema";

function ratesFromForm(values: OfferFormValues) {
	return Object.entries(values.rates)
		.filter(([, percent]) => percent !== "" && percent !== undefined)
		.map(([positionId, percent]) => ({
			positionId,
			percent: Number(percent),
		}));
}

function bindingsOf(values: OfferFormValues): {
	categoryIds?: string[];
	partnerIds?: string[];
} {
	if (values.type === "EVERYONE") {
		return { categoryIds: undefined, partnerIds: undefined };
	}

	if (values.type === "CORPORATE") {
		return { categoryIds: undefined, partnerIds: values.partnerIds };
	}

	return { categoryIds: values.categoryIds, partnerIds: undefined };
}

export function offerCreateBody(values: OfferFormValues): CreateDiscountBody {
	return {
		name: values.name,
		type: values.type,
		promoCode: values.promoCode || undefined,
		isActive: values.isActive,
		...(values.type === "EVERYONE" && values.endsOn
			? { endsOn: values.endsOn }
			: {}),
		...bindingsOf(values),
		rates: ratesFromForm(values),
	};
}

export function offerUpdateBody(values: OfferFormValues): UpdateDiscountBody {
	return {
		name: values.name,
		promoCode: values.promoCode || null,
		isActive: values.isActive,
		...(values.type === "EVERYONE" ? { endsOn: values.endsOn || null } : {}),
		...bindingsOf(values),
		rates: ratesFromForm(values),
	};
}
